import TableActionButton from 'components/reusableComponents/buttons/TableActionButton';
import BurnOverlayComponent from 'components/search/burnOverlay/BurnOverlayComponent';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { BurnerJob } from 'reducers/printersReducer';

type JobsActionProps = {
  job: BurnerJob;
  cancelJob: (jobId: string, burner: string) => void;
};

const JobActions = ({ job, cancelJob }: JobsActionProps) => {
  if (job !== undefined) {
    if (job.burner === 'UNKNOWN') return <React.Fragment></React.Fragment>;

    // print again button
    if (
      //if epson and status is end-of-process
      (job.burnerModel === 'EPSON_P100' && parseInt(job.statusCode) >= 4 && parseInt(job.statusCode) <= 6) ||
      //if rimage and status is end-of-process
      (job.burnerModel === 'RIMAGE_2000I' &&
        (job.statusCode === 'DON' || job.statusCode === 'ERR' || job.statusCode === 'CAN'))
    ) {
      return (
        <OverlayTrigger trigger="click" rootClose placement="left" overlay={BurnOverlayPopup(job)}>
          <span style={{ display: 'flex' }}>
            <TableActionButton action={() => {}} icon="faRedo" tooltip="Open Redo Overlay" key={job.id + '_redo'} />
          </span>
        </OverlayTrigger>
      );
    }
    // cancel order button
    if (job.burnerModel === 'EPSON_P100' && parseInt(job.statusCode) <= 3)
      return (
        <span style={{ display: 'flex' }}>
          <TableActionButton
            action={() => cancelJob(job.id, job.burner)}
            key={job.id + 'cancel'}
            icon="faTimes"
            tooltip="Cancel Job"
          />
        </span>
      );
  }
  return <React.Fragment></React.Fragment>;
};

const BurnOverlayPopup = job => (
  <Popover id="forward-popover">
    <BurnOverlayComponent job={job} />
  </Popover>
);

export default JobActions;
